import { render, staticRenderFns } from "./splash_shinhan.vue?vue&type=template&id=45fafb8b&scoped=true&"
import script from "./splash_shinhan.vue?vue&type=script&lang=js&"
export * from "./splash_shinhan.vue?vue&type=script&lang=js&"
import style0 from "./splash_shinhan.vue?vue&type=style&index=0&id=45fafb8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fafb8b",
  null
  
)

export default component.exports